module.exports = __webpack_public_path__ + "static/media/customer010.8428863c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/img/customer010.jpg
// module id = 857
// module chunks = 0